// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2r269","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2zNrq","obliqueLine":"membershipbadge_obliqueLine__vyDAJ"};